import { defineComponent as _defineComponent } from 'vue'
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import CountryList from '@/features/buybox/components/CountryList.vue';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySwitcherModal',
  props: {
    countrySelectedCallback: null,
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as {
	countrySelectedCallback?: (() => void) | null;
	additionalContexts?: SnowplowContext[];
};



async function closeSelf() {
	props.countrySelectedCallback?.();
	VFMHelper.close();
}

return { __sfc: true,props, closeSelf, BaseModal, CountryList }
}

})